import axios from "axios";
import { Environment } from "../../../environment";
import { errorInterceptor, responseInterceptor } from "./interceptors";

const Api = axios.create({
    baseURL: Environment.URL_API,
});

Api.interceptors.request.use((config) => {
    // Usa o token fixo da landing page do .env
    const token = process.env.REACT_APP_LANDING_PAGE_TOKEN;
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = token;
    }
    return config;
});

Api.interceptors.response.use(
    (response) => responseInterceptor (response),
    (error) => errorInterceptor(error),
);

const FakeApi = axios.create({
    baseURL: Environment.URL_BASE,
})

FakeApi.interceptors.response.use(
    (response) => responseInterceptor (response),
    (error) => errorInterceptor(error),
);
 
export {Api, FakeApi}; 
